export const NEW_ROLE_NAME = 'Role Name';

export const NEW_GROUP_NAME = 'Group Name';
